<template>
    <div class="teclado">
           <button class="teclado-button" v-for="(letra,key) in 'abcdefghijklmnopqrstuvwxyz'"
            :key="key" :disable="verificarLetra(letra)" v-on:click="jogar(letra)">{{letra}}
            </button> 
    </div>
</template>

<script>
export default{
    name:'Teclado',
    props:{
        letras: Array,
        verificarLetra: Function,
        jogar: Function
    }
}

</script>


<style scoped>

.teclado{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 80%;
    margin-top: 15px;
}
.teclado-button{
margin:5px;
width: 40px;
height: 30px;
background: var(--color-background-button);
outline: none;
border:none;
text-transform: uppercase;
color:#fff;
font-weight: bold;
cursor: pointer;
box-shadow: 1px 2px 1px 2px rgba(8,70,168,0.3);
position: relative;
transition: 0.8s linear;
border-radius: 5px;
}
.teclado-button:hover{
    transform: scale(10px);
    transform: translate(1px);
    box-shadow: 1px 1px 0px 1px rgba(8,70,168,0.2);
    filter:brightness(20px);
    filter:brightness(1.5);
}

button[disable]{
    opacity:0.5;
    pointer-events: none;
}

</style>
